export default __webpack_public_path__ + "static/tv-show-7-72d61d4a16b443789ddfeae720234229.jpg";